import { render, staticRenderFns } from "./EditSelfMedicationModal.vue?vue&type=template&id=645472f6&scoped=true"
import script from "./EditSelfMedicationModal.vue?vue&type=script&lang=js"
export * from "./EditSelfMedicationModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645472f6",
  null
  
)

export default component.exports